import { render, staticRenderFns } from "./NoticeInfoView.vue?vue&type=template&id=88dee080&scoped=true&"
import script from "./NoticeInfoView.vue?vue&type=script&lang=js&"
export * from "./NoticeInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dee080",
  null
  
)

export default component.exports